// prettier-ignore
export const spacing = {
  xxxxs: '0.25rem',  // 4px
  xxxs: '0.5rem',     // 8px
  xxs: '0.75rem',     // 12px
  xs: '0.875rem',     // 14px
  sm: '1rem',         // 16px
  md: '1.5rem',       // 24px
  lg: '2rem',         // 32px
  xl: '3rem',         // 48px
  xxl: '4rem',        // 64px
  xxxl: '4.5rem',     // 72px
  xxxxl: '6rem',      // 96px
}
